import { useEffect } from 'react';
import * as Services from './DetailService';
import { useState } from 'react';
import {
  CreditVoutherComponent,
  DelegationComponent,
  DiscountVoutherComponent,
  FactorComponent,
  TransferCreditComponent,
  WithrawComponent
} from './index';
export default function Details({ data , currencyText}) {


  
  const [parsData, setParseData] = useState([]);
  const [status, setStatus] = useState(data?.multiConfirmationSrv?.typeCode);

  const typeCodeEnum = {
    MULTI_CONFIRMATION_TYPE_DELEGATION_RULE: 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE', //تفویض وجه
    MULTI_CONFIRMATION_TYPE_TRANSFER: 'MULTI_CONFIRMATION_TYPE_TRANSFER', //, انتقال وجه
    MULTI_CONFIRMATION_TYPE_SETTLEMENT: 'MULTI_CONFIRMATION_TYPE_SETTLEMENT', // برداشت وجه

    MULTI_CONFIRMATION_TYPE_INVOICE: 'MULTI_CONFIRMATION_TYPE_INVOICE', //   فاکتور
    MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER: 'MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER', // بن تخفیف مبلغی
    MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER: 'MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER', //,بن تخفیف درصدی
    MULTI_CONFIRMATION_TYPE_VOUCHER: 'MULTI_CONFIRMATION_TYPE_VOUCHER', // بن
  };

  useEffect(() => {
    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_SETTLEMENT) {
      // برداشت
      if (data?.requestFile || data?.requestFileHashCode) {
        // گروهی
        setParseData(Services.WithrawFields(data, true , currencyText));
      } else {
        // تکی
        setParseData(Services.WithrawFields(data ,false , currencyText));
      }
    }
    if (
      status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_DELEGATION_RULE
    ) {
      // تفویض
      if (data?.requestFile || data?.requestFileHashCode) {
        // گروهی
        setParseData(Services.delegationFields(data, true ,  currencyText));
      } else {
        // تکی
        setParseData(Services.delegationFields(data ,false ,  currencyText));
      }
    }
    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_TRANSFER) {
      // انتقال
      if (data?.requestFile || data?.requestFileHashCode) {
        // گروهی
        setParseData(Services.transferCreditFields(data, true ,  currencyText));
      } else {
        // تکی
        setParseData(Services.transferCreditFields(data , false, currencyText));
      }
    }

    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_INVOICE) { // فاکتور
      setParseData(Services.factorFields(data  ,  currencyText));
    }

    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_VOUCHER) { // بن شارژ
      setParseData(Services.creditVoutherFields(data ,  currencyText));
    }

    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER ||
      status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER) { // بن تخفیف

      setParseData(Services.discountVoutherFields(data ,  currencyText));
    }

  }, []);
  /**
   * میخوایم بر اساس تایپ کد، کامپوننت صحیح را رندر کنیم
   */
  const renderHtml = (statusss) => {
    if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_SETTLEMENT) { // برداشت
      return <WithrawComponent data={parsData} />;
    } else if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_DELEGATION_RULE) { // تفویض
      return <DelegationComponent data={parsData} />
    } else if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_TRANSFER) { // انتقال
      return <TransferCreditComponent data={parsData} />;
    } else if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_INVOICE) { // فاکتور
      return <FactorComponent data={parsData} />
    } else if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_VOUCHER) { // بن شارژ
      return <CreditVoutherComponent data={parsData} />
    } else if (status == typeCodeEnum.MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER ||
      typeCodeEnum.MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER) { // بن تخفیف- مقداری | درصدی
      return <DiscountVoutherComponent data={parsData} />
    } else {
      return null;
    }
  }
  
  return (
    <>
      {
        renderHtml(data?.multiConfirmationSrv?.typeCode)
      }
    </>
  );
}
